import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";

const includes = [
  "MVP development (AI-assisted, security-first)",
  "Product iteration based on real user feedback",
  "AI workflow deployment & integration",
  "Technical leadership and architecture decisions",
  "Launch execution and first-traction playbooks",
  "Weekly operating cadence with clear milestones",
];

export default function BuildAndLaunch() {
  return (
    <section id="build-and-launch" aria-label="Build and Launch" className="editorial-container section-spacing">
      <hr className="editorial-rule mb-16 lg:mb-20" />

      {/* Label */}
      <ScrollReveal>
        <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
          BUILD &amp; LAUNCH
        </p>
      </ScrollReveal>

      {/* Headline */}
      <ScrollReveal stagger={1}>
        <h2 className="mt-6 max-w-3xl font-display text-section font-bold text-foreground md:text-section-md lg:text-section-lg">
          The Build &amp; Launch
        </h2>
      </ScrollReveal>

      {/* Subtitle */}
      <ScrollReveal stagger={2}>
        <p className="mt-4 max-w-2xl text-body-lg text-foreground-muted md:text-body-lg-md">
          Your operator. Your builder. Your first technical co-founder.
        </p>
      </ScrollReveal>

      {/* Intro */}
      <ScrollReveal stagger={3}>
        <p className="mt-8 max-w-3xl text-foreground-muted md:text-body-md">
          After the Sprint, some founders try to build alone. A few pull it off.
          Most can&rsquo;t. Not because they&rsquo;re incapable, but because
          building an MVP takes pattern recognition and technical judgment
          that only comes from doing this repeatedly.
        </p>
      </ScrollReveal>

      {/* Includes */}
      <ScrollReveal className="mt-12">
        <h3 className="font-display text-subsection font-semibold text-foreground md:text-subsection-md">
          What&rsquo;s Included
        </h3>
      </ScrollReveal>

      <ScrollReveal stagger={1} className="mt-6">
        <ul className="space-y-3">
          {includes.map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span
                aria-hidden="true"
                className="mt-0.5 shrink-0 text-accent"
              >
                ✓
              </span>
              <span className="text-foreground-muted">{item}</span>
            </li>
          ))}
        </ul>
      </ScrollReveal>

      {/* Callout */}
      <ScrollReveal className="mt-16">
        <div className="border-l-2 border-accent bg-accent-subtle py-4 pl-6">
          <p className="text-body-lg font-medium text-foreground md:text-body-lg-md">
            Not a dev shop. Not an advisor. A builder who&rsquo;s been through
            it and has the scars to prove it.
          </p>
        </div>
      </ScrollReveal>

      <ScrollReveal className="mt-10">
        <Link
          to="/build-launch"
          className="group inline-flex items-center gap-2 font-body text-cta uppercase text-accent transition-all duration-300 hover:gap-4"
        >
          FULL BUILD &amp; LAUNCH DETAILS
          <span aria-hidden="true" className="inline-block transition-transform duration-300 group-hover:translate-x-0.5">→</span>
        </Link>
      </ScrollReveal>
    </section>
  );
}
